import {Breakpoints, ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiAccordion = ({accordion}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => ({
  MuiAccordion: {
    styleOverrides: {
      root: {
        border: `${accordion.desktop.border.width} ${accordion.desktop.border.style} ${accordion.desktop.border.color}`,
        background: accordion.desktop.background.color,
        borderLeft: 'none',
        borderRight: 'none',
        boxShadow: 'none',
        maxWidth: accordion.desktop.width.max,
        '&.Mui-expanded': {
          margin: '0px 0',
          borderTopColor: 'transparent'
        },
        '&:before': {
          backgroundColor: 'white'
        },
        '& .MuiButtonBase-root': {
          '&.Mui-focusVisible': {
            outlineOffset: 0
          },
          '& .MuiAccordionSummary-content': {
            margin: 0
          }
        },

        '& .MuiCollapse-hidden': {
          borderBottom: `${accordion.desktop.border.width} ${accordion.desktop.border.style} ${accordion.desktop.border.color}`
        },
        '& .MuiAccordionSummary-expandIconWrapper>.MuiSvgIcon-root': {
          width: accordion.control.desktop.width,
          height: accordion.control.desktop.height,
          color: accordion.control.desktop.icon.color,
          background: 'transparent',
          [mediaQueries.down('md')]: {
            width: '24px',
            height: '24px'
          }
        }
      },

      rounded: {
        '&:first-of-type': {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0
        },
        '&:last-child': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }
});

export const MuiAccordionSummary = ({accordion}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => ({
  MuiAccordionSummary: {
    defaultProps: {
      disableRipple: true,
      focusRipple: false,
      disableTouchRipple: true
    },
    styleOverrides: {
      root: {
        gap: 8,
        padding: accordion.desktop.padding.all,
        [mediaQueries.down('md')]: {
          padding: '16px'
        },
        flexDirection: 'row-reverse',

        '&.Mui-expanded': {minHeight: 'unset'},
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {transform: 'rotate(90deg)'},
        '& .MuiAccordionSummary-expandIconWrapper>.MuiSvgIcon-root': {width: 24, height: 24},

        '&:hover': {
          backgroundColor: accordion.desktop.hover.background.color
        },
        '&:focus': {
          outline: '2px solid #0C55B8'
        }
      },

      content: {
        width: '100%',
        wordBreak: 'break-word',
        '& .MuiTypography-root': {
          color: accordion.heading.desktop.font.color,
          lineHeight: accordion.heading.desktop.font.lineHeight,
          fontSize: accordion.heading.desktop.font.size,
          fontWeight: 700,
          [mediaQueries.down('md')]: {
            lineHeight: accordion.heading.mobile.font.lineHeight,
            fontSize: accordion.heading.mobile.font.size
          }
        }
      }
    }
  }
});

export const MuiAccordionDetails = ({accordion}: Tokens, mediaQueries: Breakpoints): ThemeOptions['components'] => ({
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        '& .accordiondetailImage': {
          marginRight: '16px',
          width: '90px',
          height: '90px',
          float: 'left',
          [mediaQueries.down('md')]: {
            width: '40px',
            height: '40px'
          }
        },

        '& .accordiondetailImageDetail2': {
          clear: 'left',
          marginTop: 20
        },
        padding: accordion.contentContainer.desktop.padding.all,
        [mediaQueries.down('md')]: {
          padding: '8px 16px 16px 16px'
        }
      }
    }
  }
});
